export const LINKS = {
  IMPRINT: 'https://gradoo.com/de/pages/impressum',
  DATA_CENTER: 'https://gradoo.com/de/pages/datenschutz'
} as const

export const YEARBOOK_PAGES_TABS = ['cover', 'content']
